import React from "react";
import "./GoHome.css"
import home_black from "./../../assets/home_black.png"
import home_white from "./../../assets/home_white.png"
import { useLocation,useNavigate} from 'react-router-dom';


const GoHome=(props)=>{
    const navigate=useNavigate();
    const isHome = useLocation().pathname==='/';
    const classname=`go-home-button ${isHome?'go-home-button-bk-white':'go-home-button-gradient'}`;    
    return <button  className={classname} onClick= {()=>navigate('/',{replace:true})}>
   <img src={isHome?home_black:home_white} className='go-home-image'/>
    </button>
  
}

export default GoHome ;